import { render, staticRenderFns } from "./remove-from-mtp-table-modal.vue?vue&type=template&id=7ec34879"
import script from "./remove-from-mtp-table-modal.ts?vue&type=script&lang=ts&external"
export * from "./remove-from-mtp-table-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./remove-from-mtp-table-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ec34879')) {
      api.createRecord('7ec34879', component.options)
    } else {
      api.reload('7ec34879', component.options)
    }
    module.hot.accept("./remove-from-mtp-table-modal.vue?vue&type=template&id=7ec34879", function () {
      api.rerender('7ec34879', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/remove-from-mtp-table-modal/remove-from-mtp-table-modal.vue"
export default component.exports